/* eslint-disable react-hooks/exhaustive-deps */
import LazyImage from '../LazyImage';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import styles from './post.module.scss';
import LazyVideo from '../LazyVideo';
import {
    attachClientImpressionHandler,
    trackClientExternalLink,
    trackClientVideoView
} from '../../analytics/client-event-tracking';
import { AccountContext } from '../../contexts';
import classNames from 'classnames';
import {useIntersection} from '../../hooks/useIntersection';

const INSTANT_POSTS = 10;

function Post({platform, position, post, subunit_tracking_data, toggleModal}) {
    const { id, title, enriched_link_url, image_url, multilink, video_url } = post;
    const [child, setChild] = useState(null);
    const [shouldRender, setShouldRender] = useState(true);
    const account = useContext(AccountContext);
    const { elRef } = useIntersection({
        once: true,
        rootMargin: '0px',
        threshold: 0.5,
    });

    const unitData = {
        unit_type: 'feed',
        unit_name: 'main',
        item_type: 'card',
        item_name: id.toString(),
        position_in_unit: position,
        target_content_url: multilink ? '' : enriched_link_url,
        target_content_type: 'link',
        ...subunit_tracking_data,
    };

    const rendered = shouldRender && enriched_link_url && (image_url || video_url);

    useEffect(() => {
        if (rendered && elRef.current) {
            attachClientImpressionHandler(elRef.current, account, unitData);
        }
    }, [elRef]);

    const trackPostClick = () => {
        trackClientExternalLink(account, unitData);
    };

    const trackVideoView = () => {
        trackClientVideoView(account, unitData);
    };

    useEffect(() => {
        const sharedProps = {
            title,
            hrefUrl: enriched_link_url,
            imageUrl: image_url,
            post,
            width: elRef.current ? elRef.current.offsetWidth : 0,
            className: styles.postContent,
            shouldRender: (bool) => setShouldRender(bool),
            trackPostClick,
            toggleModal,
            notLazy: (position <= INSTANT_POSTS)
        };

        setChild(video_url ?
            <LazyVideo {...sharedProps} videoUrl={video_url} trackVideoView={trackVideoView} />
            : <LazyImage {...sharedProps} />);
    }, []);

    if (!rendered && position > INSTANT_POSTS) {
        return null;
    }

    return (
        <div
            ref={elRef}
            className={classNames(styles.post, platform ? styles['post--' + platform] : '')}
        >
            {child}
        </div>
    );
}

Post.propTypes = {
    position: PropTypes.number,
    post: PropTypes.shape({
        title: PropTypes.string,
        enriched_link_url: PropTypes.string,
        image_url: PropTypes.string,
        video_url: PropTypes.string
    }),
    platform: PropTypes.string,
    subunit_tracking_data: PropTypes.shape({
        subunit_type: PropTypes.string,
        subunit_name: PropTypes.string,
        position_in_unit: PropTypes.number,
        position_in_subunit: PropTypes.number
    }),
    toggleModal: PropTypes.func
};

export default Post;
